import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef, useCallback, useRef, useState } from 'react';
import { Message } from '../../primitives/internal/Message/index.js';
import { Container } from '../../primitives/TextInput/components/Container.js';
import { Icon } from '../../primitives/TextInput/components/Icon.js';
import { Input } from '../../primitives/TextInput/components/Input.js';
import { Label } from '../../primitives/TextInput/components/Label.js';
import { Wrapper } from '../../primitives/TextInput/components/Wrapper.js';
export const Field = /*#__PURE__*/_styled(forwardRef(function Field({
  id,
  label,
  message,
  placeholder = ' ',
  name,
  value,
  disabled,
  invalid,
  fullWidth,
  visuallyFocused,
  className,
  appendIcon,
  prependIcon,
  onFocus,
  onBlur,
  size = 'medium',
  variant = 'info',
  allowOverflow,
  type = 'text',
  inputRef: inputRefFromProps = null,
  ...restProps
}, ref) {
  const [focused, setFocused] = useState(false);
  const inputRefLocal = useRef(null);
  const inputRef = inputRefFromProps || inputRefLocal;
  const handleFocus = useCallback(event => {
    if (onFocus) {
      onFocus(event);
    }
    setFocused(true);
  }, [onFocus]);
  const handleBlur = useCallback(event => {
    if (onBlur) {
      onBlur(event);
    }
    setFocused(false);
  }, [onBlur]);
  const handleIconClick = useCallback(() => {
    if (!inputRef.current) {
      return;
    }
    if (focused) {
      inputRef.current.blur();
    } else {
      inputRef.current.focus();
    }
  }, [focused, inputRef]);
  return _jsxs(Wrapper, {
    fullWidth: fullWidth,
    ref: ref,
    children: [_jsxs(Container, {
      size: size,
      className: className,
      invalid: invalid,
      disabled: disabled,
      // @ts-expect-error TS(2322) FIXME: Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
      focused: focused || visuallyFocused,
      variant: variant,
      children: [prependIcon && _jsx(Icon, {
        onClick: handleIconClick,
        size: size,
        "data-testid": "textfield-prepend-icon",
        children: prependIcon
      }), _jsx(Input
      // @ts-expect-error (TS2322) FIXME: Type RefObject<HTMLInputElement | null> is not assignable to type Ref<HTMLInputElement> | undefined>
      , {
        // @ts-expect-error (TS2322) FIXME: Type RefObject<HTMLInputElement | null> is not assignable to type Ref<HTMLInputElement> | undefined>
        ref: inputRef,
        id: id,
        allowOverflow: allowOverflow,
        disabled: disabled,
        name: name,
        placeholder: placeholder,
        value: value,
        size: size,
        onFocus: handleFocus,
        onBlur: handleBlur,
        type: type,
        "aria-label": label,
        ...restProps
      }), placeholder === ' ' && _jsx(Label, {
        tabIndex: -1,
        "data-testid": "label",
        disabled: disabled,
        htmlFor: id,
        children: label
      }), appendIcon && _jsx(Icon, {
        onClick: handleIconClick,
        size: size,
        children: appendIcon
      })]
    }), message && _jsx(Message, {
      "data-testid": "message",
      invalid: invalid,
      children: message
    })]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e17gdn9f0"
} : {
  target: "e17gdn9f0",
  label: "Field"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");